export const FETCH_RESULTS = 'third-party-app-directory/FETCH_RESULTS';
export const FETCH_RESULTS_FAILURE =
  'third-party-app-directory/FETCH_RESULTS_FAILURE';
export const FETCH_RESULTS_SUCCESS =
  'third-party-app-directory/FETCH_RESULTS_SUCCESS';
export const FETCH_SCOPES = 'third-party-app-directory/FETCH_SCOPES';
export const FETCH_SCOPES_FAILURE =
  'third-party-app-directory/FETCH_SCOPES_FAILURE';
export const FETCH_SCOPES_SUCCESS =
  'third-party-app-directory/FETCH_SCOPES_SUCCESS';
